import React from 'react';
import { FieldControlProps } from '../FieldRenderer';
import { sliderRange } from '../reportFormUtils';

// display_style: plain (default) | slider
const NumberInput: React.FC<FieldControlProps> = ({ field, value, onChange }) => {
  const { min, max, step } = field.validation ?? {};
  const numValue = typeof value === 'number' ? value : undefined;

  if (field.display_style === 'slider') {
    // The value starts at default_value or min (buildInitialValues), so what
    // the slider shows is always what gets submitted.
    const range = sliderRange(field);
    const shown = numValue ?? range.min;
    return (
      <div className="report-field-slider">
        <input
          type="range"
          aria-label={field.field_label}
          min={range.min}
          max={range.max}
          step={step ?? 1}
          value={shown}
          onChange={(e) => onChange(Number(e.target.value))}
        />
        <span className="report-field-slider-value">{shown}</span>
      </div>
    );
  }

  return (
    <input
      type="number"
      className="report-field-input"
      aria-label={field.field_label}
      value={numValue ?? ''}
      placeholder={field.placeholder}
      min={min}
      max={max}
      step={step}
      onChange={(e) => onChange(e.target.value === '' ? null : Number(e.target.value))}
    />
  );
};

export default NumberInput;
